import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core';

import { PushPipe } from '@ngrx/component';
import { BehaviorSubject } from 'rxjs';

import { OverlayContentDirective } from './overlay-content-directive.directive';

@Component({
  selector: 'ui-overlay-button',
  templateUrl: './overlay-button.component.html',
  styleUrls: ['./overlay-button.component.scss'],
  imports: [NgTemplateOutlet, OverlayModule, PushPipe, A11yModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayButtonComponent {
  @ContentChild(OverlayContentDirective, { read: TemplateRef }) content!: TemplateRef<OverlayContentDirective>;

  public overlayOpen$ = new BehaviorSubject<boolean>(false);

  public get isOpen(): boolean {
    return this.overlayOpen$.getValue();
  }

  public close(): void {
    this.overlayOpen$.next(false);
  }

  public handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  public open(): void {
    this.overlayOpen$.next(true);
  }
}
